import { Duration } from 'luxon';
import React from 'react';

interface TooltipProps {
    title: string;
    content: { name: string; value: string }[];
    age?: number;
}

export const Tooltip = ({ title, content, age }: TooltipProps) => {
    const duration = age ? Duration.fromMillis(age) : undefined;

    const durationString = duration && duration?.milliseconds > 60 * 1000 ? duration?.toFormat("m'm' s's'") : duration?.toFormat("s's'");
    return (
        <div style={{ width: 270, color: '#172344', fontSize: 14, lineHeight: '20px', letterSpacing: '0px', fontFamily: 'Open Sans' }}>
            <div style={{ fontWeight: 700, fontSize: 16, lineHeight: '22px' }}>{title}</div>
            <hr style={{ border: 'none', borderBottom: '1px #CDCDCD solid', marginBottom: 0 }} />
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                {content.map((item, i) => (
                    <div key={i} style={{ display: 'flex', whiteSpace: 'nowrap', marginTop: 16 }}>
                        <div style={{ width: '50%', textAlign: 'start' }}>{item.name}</div>
                        <div style={{ width: '50%', textAlign: 'end', fontWeight: 600 }}>{item.value}</div>
                    </div>
                ))}
            </div>
            {durationString && <div style={{ marginTop: 16, fontSize: 12, lineHeight: '18px', color: '#595959' }}>{durationString + ' ago'}</div>}
        </div>
    );
};
